import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import { Link, useNavigate } from "react-router";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InfoCardsOrder from "../Components/Orders/InfoCardsOrder";
import Sidebar from "../Components/Sidebar";
import { useOrderStore } from "../store/useOrderStore";
import { formatDate, formatTime } from "../Components/formateDate";
import {
  Box,
  Button,
  MenuItem,
  Modal,
  Pagination,
  Select,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import Loader from "../Components/loader/Loader";

export default function Orders() {
  const navigate = useNavigate();
  const { getAllOrder, order, loading, deleteorder, dowloadOrderList } =
    useOrderStore();
  const [totalPages, setTotalPages] = useState(1);
  const [loadingStyle, setLoadingStyle] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [field, setField] = useState("");
  const [filterByDay, setFilterByDay] = useState("");
  const [filterByOrder, setFilterByOrder] = useState("");
  const [filterByStatus, setFilterbyStatus] = useState("");
  const [dateRange, setDateRange] = useState(" ");
  const [deleteId, setDeleteID] = useState(null);
  const [open, setOpen] = useState(false);

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  const handleCancelDelete = () => {
    setOpen(false);
  };

  const handleDelete = (id) => {
    setDeleteID(id);
    setOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      console.log(deleteId);
      setOpen(false);
      const res = await deleteorder(deleteId);
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getAllOrderFunction = async () => {
      const data = await getAllOrder(
        pageNumber,
        pageSize,
        search,
        field,
        dateRange
      );
      if (data) {
        setTotalPages(data?.totalPages);
      }
    };
    getAllOrderFunction();
  }, [pageNumber, search, field, dateRange]);

  const handleView = (id) => {
    navigate(`/order/view-order?id=${encodeURIComponent(id)}`);
  };

  const handleEdit = (id) => {
    navigate(`/order/edit-order?id=${encodeURIComponent(id)}`);
  };

  const handleDowload = async () => {
    setLoadingStyle(true);
    await dowloadOrderList(pageNumber, pageSize, search, field);
    setLoadingStyle(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "filterByStatus") {
      setFilterbyStatus(value);
      setField("orderStatus");
      setSearch(value);
    } else if (name === "filterByOrder") {
      setFilterByOrder(value);
      setField("orderId");
      setSearch(value);
    }

    setPageNumber(1);
    console.log(pageNumber);
  };

  return (
    <div id="dashboard-root" className="flex min-h-[1000px] w-full">
      {/* <!-- Sidebar --> */}
      <Loader loading={loadingStyle} />
      <Sidebar />
      {/* <!-- Main Content --> */}
      <main id="main-content" className="flex-1 px-10 py-8">
        {/* <!-- Header --> */}
        <Header title="Orders" />
        {/* <!-- Orders Management Page --> */}
        <div id="orders-page" className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              {/* <h1 class="text-2xl font-bold text-gray-800">Orders</h1> */}
              <p className="text-gray-600">
                Manage customer orders and track their status
              </p>
            </div>
            <div className="flex space-x-3">
              <button className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center">
                <i className="fa-solid fa-filter mr-2"></i>
                Filter
              </button>
              <button
                className="bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700 flex items-center"
                onClick={() => handleDowload()}
              >
                <i className="fa-solid fa-download mr-2"></i>
                Export
              </button>
              {/* <Link to="/order/add-order" class="bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-4 py-2 text-sm font-medium flex items-center">
                                <i class="fa-solid fa-plus mr-2"></i>
                                Create Order
                            </Link> */}
            </div>
          </div>

          {/* <!-- Order Stats Cards --> */}
          {/* <InfoCardsOrder /> */}

          {/* <!-- Orders Table -->s */}
          <div
            id="orders-table"
            className="bg-white rounded-lg shadow overflow-hidden"
          >
            <div className="p-4 border-b flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div>
                  <select
                    className="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
                    value={filterByStatus}
                    name="filterByStatus"
                    onChange={(e) => handleChange(e)}
                  >
                    <option value="">All Orders</option>
                    <option value="Processing">Processing</option>
                    <option value="Shipped">Shipped</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>
                <div>
                  <Select
                    onChange={(e) => {
                      setDateRange(e.target.value);
                      setPageNumber(1);
                    }}
                    value={dateRange}
                    sx={{
                      "& .MuiSelect-select":
                        {
                          padding: "8px 14px",
                        },
                    }}
                  >
                    <MenuItem value=" ">All Order</MenuItem>
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="last7">Last 7 Days</MenuItem>
                    <MenuItem value="last30">Last 30 Days</MenuItem>
                    {/* <MenuItem value="custom">Custom Range</MenuItem> */}
                  </Select>
                </div>
              </div>
              <div className="relative">
                <input
                  type="text"
                  value={filterByOrder}
                  name="filterByOrder"
                  onChange={(e) => handleChange(e)}
                  placeholder="Search orders..."
                  className="border rounded-lg px-3 py-2 text-sm w-64"
                />
                <i
                  className="fa-solid fa-search absolute right-3 text-gray-400"
                  style={{ top: "0.375rem" }}
                ></i>
              </div>
            </div>
            <div className="overflow-x-auto">
              {
                <table className="w-full">
                  <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <tr>
                      <th className="p-4">Order ID</th>
                      <th className="p-4">Customer</th>
                      <th className="p-4">Date</th>
                      <th className="p-4">Items</th>
                      <th className="p-4">Total</th>
                      <th className="p-4">Payment</th>
                      <th className="p-4">Status</th>
                      <th className="p-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {loading
                      ? Array.from({ length: 5 }).map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                          {Array.from({ length: 8 }).map((_, colIndex) => (
                            <TableCell key={colIndex}>
                              <Skeleton variant="text" animation="wave" />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                      : (order || []).map((ele, i) => (
                        <tr className="hover:bg-gray-50" key={i}>
                          <td className="p-4 font-medium text-gray-800">
                            {ele?.orderId}
                          </td>
                          <td className="p-4">
                            <div className="flex items-center">
                              <img
                                src={ele?.user?.avatar}
                                alt="Customer"
                                className="w-8 h-8 rounded-full mr-3"
                              />
                              <div>
                                <div className="font-medium text-gray-800">
                                  {ele?.user?.fullName}
                                </div>
                                <div className="text-xs text-gray-500">
                                  {ele?.user?.email}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="p-4 text-gray-600">
                            <div>{formatDate(ele?.createdAt)}</div>
                            <div className="text-xs text-gray-500">
                              {formatTime(ele?.createdAt)}
                            </div>
                          </td>
                          <td className="p-4 text-gray-600">
                            {ele?.items.length}
                          </td>
                          <td className="p-4 font-medium text-gray-800">{`$${ele.totalAmountAfterCoupon}`}</td>
                          <td className="p-4">
                            <span
                              className={`px-2 py-1 rounded-full text-xs
      ${ele?.paymentStatus === "Paid" ? "bg-green-100 text-green-800" : ""}
      ${ele?.paymentStatus === "Pending" ? "bg-yellow-100 text-yellow-800" : ""}
      ${ele?.paymentStatus === "Failed" ? "bg-red-100 text-red-800" : ""}`}
                            >
                              {ele?.paymentStatus}
                            </span>
                          </td>

                          <td className="p-4">
                            <span
                              className={`px-2 py-1 rounded-full text-xs
    ${ele?.status === "Processing" ? "bg-blue-100 text-blue-800" : ""}
    ${ele?.status === "Shipped" ? "bg-indigo-100 text-indigo-800" : ""}
    ${ele?.status === "Delivered" ? "bg-green-100 text-green-800" : ""}
    ${ele?.status === "Cancelled" ? "bg-red-100 text-red-800" : ""}`}
                            >
                              {ele?.status}
                            </span>
                          </td>
                          <td className="p-4">
                            <div className="flex space-x-2">
                              <button
                                className="text-gray-500 hover:text-primary-600"
                                onClick={() => handleView(ele?._id)}
                              >
                                <i className="fa-solid fa-eye"></i>
                              </button>
                              <button
                                className="text-gray-500 hover:text-primary-600"
                                onClick={() => handleEdit(ele?._id)}
                              >
                                <i className="fa-solid fa-pencil"></i>
                              </button>
                              <button
                                className="text-gray-500 hover:text-red-600"
                                onClick={() => handleDelete(ele?._id)}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              }
            </div>
            <Modal
              open={open}
              onClose={handleCancelDelete}
              aria-labelledby="confirm-delete-modal"
              aria-describedby="modal-to-confirm-deletion"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "5px",
                  boxShadow: 24,
                  width: { xs: "80%", md: "500px" },
                  textAlign: "center",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Are you sure you want to delete this Order?
                </Typography>
                <Button
                  variant="outlined"
                  color="#274156"
                  onClick={handleConfirmDelete}
                >
                  Yes
                </Button>
                <Button
                  variant="outlined"
                  color="#274156"
                  onClick={handleCancelDelete}
                  sx={{ marginLeft: "10px" }}
                >
                  No
                </Button>
              </Box>
            </Modal>
            <Stack spacing={2} className="flex items-center mt-6 mb-4 ">
              <Pagination
                count={totalPages}
                onChange={handleChangePagination}
                variant="outlined"
                shape="rounded"
              />
            </Stack>
          </div>
        </div>
      </main>
    </div>
  );
}
